import React from 'react';
import { ColorVariantSpecific } from './colorVariant';
import { isColor, isCurtain, isDecal, isPillow, isRug, isTexture, isWallPrint } from "../../../services/utils";
import { TextureVariantSpecific } from "./textureVariant";
import { DecalVariantSpecific } from "./decalVariant";
import { inject, observer } from "mobx-react";
import { UploadImage } from '../uploadImage';
import { toJS } from "mobx";
import { VariationsLinks } from "./variationsLinks";
import { VariantWithSizeSpecific } from "./variantWithSize";
import { RugVariantSpecific } from "./rugVariant";
import { CurtainVariantSpecific } from "./curtainVariant";
import { ResizableVariantSpecific } from "./resizableVariant";
import { ExternalDataList } from "./externalData/externalDataList";
import { Card, Form, Switch, Divider } from 'antd';

// Floor/wall items, beds (mirrors the pipeline's SIZE_ITEM_TYPES) and curtains (width/height ranges).
const supportsResizable = (type) =>
    ['WallItem', 'FloorItem', 'Crib', 'ToddlerBed', 'TwinBed', 'QueenBed', 'Bassinet', 'Curtain'].includes(type);

@inject('currentItem')
@observer
export class Variant extends React.Component {
    changeAvailableInCatalog = (checked) => this.props.variant.setAvailableInCatalog(checked);
    onImageChange = (imgId) => this.props.variant.setImageId(imgId);
    changeTypeSpecific = (key, value) => this.props.variant.setTypeSpecific(key, value);

    render() {
        const values = toJS(this.props.variant);
        const { type } = this.props;

        return (
            <Form
                layout="horizontal"
                labelAlign="left"
                labelCol={{ flex: '140px' }}
                wrapperCol={{ flex: 'auto' }}
                style={{ width: '100%' }}
            >
                <Form.Item label="Variations">
                    <VariationsLinks
                        variationsTypes={this.props.currentItem.variationsTypes}
                        variationsIds={this.props.variant.variationsIds}
                    />
                </Form.Item>

                <Form.Item label="Show in catalog" valuePropName="checked">
                    <Switch
                        checked={values.availableInCatalog}
                        onChange={this.changeAvailableInCatalog}
                    />
                </Form.Item>

                <Form.Item label="Image">
                    <UploadImage imageId={values.imageId} onImageIdChange={this.onImageChange} />
                </Form.Item>

                <Form.Item label="Purchase options" wrapperCol={{ span: 16 }}>
                    <ExternalDataList variantStore={this.props.variant} />
                </Form.Item>

                {(isColor(type) || isTexture(type) || isDecal(type) || isWallPrint(type) || isPillow(type) || isRug(type) || isCurtain(type) || supportsResizable(type)) && (
                    <>
                        <Divider style={{ margin: '8px 0' }} />
                        {isColor(type) && <ColorVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {isTexture(type) && <TextureVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {isDecal(type) && <DecalVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {(isWallPrint(type) || isPillow(type)) && <VariantWithSizeSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {isRug(type) && <RugVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {isCurtain(type) && <CurtainVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                        {supportsResizable(type) && <ResizableVariantSpecific variant={values} onChange={this.changeTypeSpecific} />}
                    </>
                )}
            </Form>
        );
    }
}
